import "./UserLanguageSelect.css";
import useUser from "../../hooks/user";
import { useEffect, useMemo } from "react";
import { useLogEvent } from "../../hooks/log";
import LanguageSelect from "./LanguageSelect";
import { Color } from "./Button";

function UserLanguageSelect(props: {
  languages: string[];
  color?: Color;
  borderColor?: Color;
  backgroundColor?: Color;
}) {
  const [user, setUser] = useUser();

  const selectedLanguage = useMemo(() => {
    let language = user.metadata.selectedLanguage;
    if (
      props.languages.length &&
      !props.languages.includes(user.metadata.selectedLanguage)
    ) {
      // Default to first in list
      language = props.languages[0];
      setUser((prevState) => ({
        ...prevState,
        metadata: {
          ...prevState.metadata,
          selectedLanguage: language,
        },
      }));
    }
    return language;
  }, [setUser, props.languages, user.metadata.selectedLanguage]);

  const logEvent = useLogEvent();
  useEffect(() => {
    logEvent({
      type: "select_language",
      details: {
        language: selectedLanguage,
      },
    });
  }, [logEvent, selectedLanguage]);

  return (
    <LanguageSelect
      color={props.color}
      borderColor={props.borderColor}
      backgroundColor={props.backgroundColor}
      selectedLanguage={selectedLanguage}
      onChange={(language) =>
        setUser((prevState) => ({
          ...prevState,
          metadata: { ...prevState.metadata, selectedLanguage: language },
        }))
      }
      languages={props.languages}
    />
  );
}

export default UserLanguageSelect;
